import { PaymentConfig, UserGeolocation } from "@base/types";

export const DEFAULT_OFFER_TIME = 599000;
export const DEFAULT_UPSELL_OFFER_TIME = 599000;

export const DEFAULT_GEOLOCATION: UserGeolocation = {
  countryCode: "US",
  city: "Chicago",
  lat: 41.8832,
  lon: 87.6324,
};

export const DEFAULT_PAYMENT_CONFIG: PaymentConfig = {
  currency: "usd",
  currencyLocaleFormat: "en-US",
  paymentCampaignID: "9",
};
